export default class ExpressaoBusca {
    static converterParaExibicao(expressao) {
        expressao = expressao.replaceAll(" AND ", " E ");
        expressao = expressao.replaceAll(" OR ", " OU ");
        expressao = expressao.replaceAll(" NOT ", " NÃO ");
        return expressao;
    }
}